module.exports = __webpack_public_path__ + "static/media/ResumeandLinkedIn.746bff39.png";